/* eslint-disable no-restricted-syntax */
export default [
  {
    path: '/fish/:pathMatch(.*)',
    redirect: '/fish/map',
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/fish/map',
  },
]
